export { ScormWrapperService } from './services';
export { ScormWrapperModule } from './scorm-wrapper.module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts